import { render, staticRenderFns } from "./index.vue?vue&type=template&id=cdb26c32&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=cdb26c32&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdb26c32",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/重构-快递前端-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cdb26c32')) {
      api.createRecord('cdb26c32', component.options)
    } else {
      api.reload('cdb26c32', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=cdb26c32&scoped=true", function () {
      api.rerender('cdb26c32', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/collectionCenter/BasicData/carNumber/index.vue"
export default component.exports